export default __webpack_public_path__ + "static/media/arrow.fdb6edf9.png";